import { Box, Container, SxProps, useMediaQuery } from "@mui/material";
import { Button } from "@samdesk/components/Button";
import { Heading } from "@samdesk/components/Heading";
import { Stack } from "@samdesk/components/Stack";
import { Text } from "@samdesk/components/Text";
import AuthBackgroundImage from "images/authBackground.png";
import samdeskLogo from "images/samdeskFontLogo.png";
import theme from "theme";
import EnhancedOutlet from "ui-library/EnhancedOutlet";

const AuthOutlet = () => {
	const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

	return (
		<Container
			component="main"
			disableGutters={true}
			maxWidth={false}
			sx={authWrapperSx(isDesktop)}
		>
			<Box sx={authLeftPanelSx(isDesktop)}>
				<Box component="img" src={samdeskLogo} sx={samLogoSx} />
				<EnhancedOutlet />
			</Box>
			{isDesktop && (
				<Box sx={authRightPanelSx}>
					<Box sx={textWrapperSx}>
						<Stack alignItems="start" spacing="larger">
							<Heading level="1" multiline>
								Real-time crisis alerts <br /> powered by AI.
							</Heading>
							<Text>
								We help you protect your people, assets, and brand when it
								matters most.
							</Text>
							<Button
								href="https://www.samdesk.io/"
								icon="forward"
								iconPosition="end"
								label="Request access"
								target="_blank"
							/>
						</Stack>
					</Box>
				</Box>
			)}
		</Container>
	);
};

export default AuthOutlet;

/** STYLES */

const authLeftPanelSx = (isDesktop: boolean): SxProps => ({
	display: "flex",
	flexDirection: "column",
	height: "100%",
	alignItems: "center",
	justifyContent: "safe center",
	margin: isDesktop ? "0 80px" : "0 40px",
	padding: "100px 0",
	maxWidth: isDesktop ? "550px" : "unset",
	overflowX: "hidden",
	overflowY: "auto",
	position: "relative",
	textAlign: "center",
	width: isDesktop ? "100%" : "unset",
});

const authRightPanelSx: SxProps = {
	"&::before": {
		backgroundImage: `url(${AuthBackgroundImage})`,
		backgroundRepeat: "no-repeat",
		backgroundSize: "cover",
		content: '""',
		height: "100%",
		opacity: 0.75,
		position: "absolute",
		width: "100%",
		zIndex: -1,
	},

	alignItems: "center",
	display: "flex",
	height: "100%",
	position: "relative",
	width: "100%",
	zIndex: 1,
};

const authWrapperSx = (isDesktop: boolean): SxProps => ({
	display: isDesktop ? "flex" : "inherit",
	height: "100vh",
});

const samLogoSx: SxProps = {
	position: "absolute",
	top: "40px",
	left: "40px",
};

const textWrapperSx: SxProps = {
	padding: "4rem",
};
